// Encapsulates the generate-fix API call for a single listing issue.
import { useCallback } from 'react';
import { generateFix } from '../services/catalogueHealthApi';

const useFixGeneration = (token, { skuId, asin, productName, productType }) => {
  const generate = useCallback(
    (issue) =>
      generateFix(token, {
        sku: skuId,
        asin,
        product_title: productName,
        product_type: productType,
        issue: {
          code: issue.code,
          message: issue.message,
          severity: issue.severity,
          attributes: issue.attributes ?? [],
        },
      }),
    [token, skuId, asin, productName, productType]
  );

  return { generate };
};

export default useFixGeneration;
